var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Form, Field } from 'react-redux-form';
import { Icon } from "../../UI";

class TocForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  indentButton(direction, tocElement) {
    const { indent } = this.props;
    const onClick = indent.bind(
      null,
      tocElement,
      tocElement.indentation + (direction === 'more' ? 1 : -1)
    );
    return (/*#__PURE__*/
      _jsx("button", { type: "button", onClick: onClick, className: `toc-indent-${direction} btn btn-default` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: direction === 'more' ? 'arrow-right' : 'arrow-left' })
      ));

  }

  submit(toc) {
    this.props.onSubmit(toc, this.props.file._id);
  }

  render() {
    const { toc, model, removeEntry } = this.props;
    return (/*#__PURE__*/
      _jsx(Form, { className: "toc", id: "tocForm", model: model, onSubmit: this.submit }, void 0,
      toc.map((tocElement, index) => /*#__PURE__*/
      _jsx("div", { className: `toc-indent-${tocElement.indentation}` }, index, /*#__PURE__*/
      _jsx("div", { className: "toc-edit" }, void 0,
      this.indentButton('less', tocElement),
      this.indentButton('more', tocElement), /*#__PURE__*/
      _jsx(Field, { model: `${model}[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: removeEntry.bind(this, tocElement),
        className: "btn btn-danger" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" })
      )
      )
      )
      )
      ));

  }
}

TocForm.defaultProps = {
  toc: [],
  removeEntry: () => {},
  indent: () => {},
  onSubmit: () => {}
};










export { TocForm };
export default TocForm;